import map from 'lodash/map'
import { ProductStatus } from '@ztechapps/common.contract'

export const productStatusOptions = map(ProductStatus, (item) => {
  return { label: item.value, value: item.value }
})
